module.exports = __webpack_public_path__ + "static/img/info_stage_other.328c523.png";


//////////////////
// WEBPACK FOOTER
// ./public/image/info_stage_other.png
// module id = Sn8+
// module chunks = 1